<template>
    <BaseButton
      @click.native="$event => $emit('click', $event)"
      :class="{ 'tw-button-download-active': isDownloading }"
      :size="size"
      :disabled="isDownloading"
      :variant="variant"
      v-bind="$attrs"
      :loading="false"
      data-test="download-button"
      class="l-DownloadButton">
      <ProgressRing
        v-if="isDownloading"
        :size="32"
        :stroke-width="4"
        :progress-percent="progressPercent"
        :class="svgMargin"
        class="tw-progress-ring-download mr-xs"
        data-test="progress-ring-download"
      />
      <DownloadIcon
        v-else-if="displayIcon"
        class="mr-xs"
      />
      <span>{{ text }}</span>
    </BaseButton>
  </template>

  <script>
  import BaseButton from '@/components/library/buttons/BaseButton.vue';
  import ProgressRing from '@/components/tailwind/ProgressRing.vue';
  import { DownloadIcon } from '@/components/icons/fontIcons';

  export default {
    name: 'DownloadButton',
    components: {
      BaseButton,
      ProgressRing,
      DownloadIcon,
    },
    props: {
      displayIcon: {
        type: Boolean,
        default: true,
      },
      downloadText: {
        type: String,
        required: true,
      },
      downloadingText: {
        type: String,
        required: true,
      },
      size: {
        type: String,
        required: false,
      },
      variant: {
        type: String,
        required: false,
      },
      isDownloading: {
        type: Boolean,
        required: false,
        default: false,
      },
      progressPercent: {
        type: Number,
        required: false,
        default: 0,
      },
    },
    computed: {
      text() {
        return this.isDownloading ? this.downloadingText : this.downloadText;
      },
      svgMargin() { // TODO refactor this - we need to completely rework this component with a design led solution
        if (!this.size) return 'm-progressRingLarge';
        return {
          small: 'm-progressRing',
          large: 'm-progressRingLarge',
        }[this.size];
      },
    },
  };
  </script>
